import {
  getCurrentPracticeAppointmentReturnButtonText,
  getCurrentPracticeAppointmentReturnUrl,
} from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";

export const useNavigateToReturnUrl = () => {
  const appointmentReturnUrl = useMainStore(getCurrentPracticeAppointmentReturnUrl);
  // PF-6095: the location's label, else the chain's, else the translated default.
  const returnButtonText = useMainStore(getCurrentPracticeAppointmentReturnButtonText);

  const navigateToReturnUrl = () => {
    if (appointmentReturnUrl) {
      const url =
        appointmentReturnUrl.startsWith("http://") ||
        appointmentReturnUrl.startsWith("https://")
          ? appointmentReturnUrl
          : `https://${appointmentReturnUrl}`;
      window.location.href = url;
    }
  };
  return { navigateToReturnUrl, appointmentReturnUrl, returnButtonText };
};
